export const idealPortfolioDefault = {
  value: 0,
  threshold: '',
  triggerPortfolioRequest: false,
}

const setValue = (state, value) => ({ ...state, value })

const setThreshold = (state, value) => ({ ...state, threshold: value })

const setTrigger = (state, value) => ({
  ...state,
  triggerPortfolioRequest: value,
})

const idealPortfolioActions = {
  IDEAL_PORTFOLIO_VALUE: setValue,
  IDEAL_PORTFOLIO_THRESHOLD: setThreshold,
  TRIGGER_PORTFOLIO_REQUEST: setTrigger,
}

const idealPortfolioReducer = (state, action) => {
  return idealPortfolioActions[action.type](state, action.value)
}

export default idealPortfolioReducer
